import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { IDemandRoleResponse, IDemandRole } from "./demand-role.interface";
import { DemandRoleDelegate } from "./demand-role.delegate";

export class DemandRoleService
{
    public demandRoleData: IDemandRole[] = null;
    private demandRolesubject: BehaviorSubject<IDemandRole[]> = new BehaviorSubject(null);
    public demandRoles: Observable<IDemandRole[]> = this.demandRolesubject;

    private selectedDemandRoleId: string = "0";


    constructor(private demandRoleDelegate: DemandRoleDelegate)
    {
    }

    public get demandRoleId(): string
    {
        return this.selectedDemandRoleId;
    }

    public setSelectedDemandRoleId(demandRoleId: string): void
    {
        this.selectedDemandRoleId = demandRoleId;
    }

    public getAllDemandRoles(hardReload: boolean = false)
    {
        if (this.demandRoleData !== null && this.demandRoleData.length > 0 && hardReload === false)
        {
            return;
        }
        const response = this.demandRoleDelegate.getAllDemandRoles();
        return this.processDemandRoles(response);
    }

    public getSelectedDemandRole(): IDemandRole
    {
        return this.demandRoleData.find(role => role.roleId === this.selectedDemandRoleId);
    }


    public createNewDemandRole(demandRole: IDemandRole): Observable<boolean>
    {
        demandRole.clientTimeStamp = new Date().toISOString();
        const response = this.demandRoleDelegate.createNewDemandRole(demandRole);
        return this.processDemandRoles(response);
    }

    public updateDemandRole(demandRole: IDemandRole): Observable<boolean>
    {
        demandRole.clientTimeStamp = new Date().toISOString();
        const response = this.demandRoleDelegate.updateDemandRole(demandRole);
        return this.processDemandRoles(response);
    }

    private processDemandRoles(demandResponse: Observable<IDemandRoleResponse>): Observable<boolean>
    {
        demandResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return demandResponse.pipe(mergeMap((response: IDemandRoleResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(demandResponse: IDemandRoleResponse)
        {
            if (demandResponse.success)
            {
                if (demandResponse.demandRoles.length > 0)
                {
                    this.demandRoleData = demandResponse.demandRoles;
                    this.demandRolesubject.next(this.demandRoleData);
                }
            }
        }

        function onFault(error: any)
        {
           // DemandRoleService.logger.error(`processDemands Fault - Error (${JSON.stringify(error)})`);
        }
    }
}